import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SnowComponent } from './components/snow/snow.component';
// import { DialogDruo } from './components/dialog-druo/dialog-druo.component';
import { CoreModule } from '../core/core.module';
import { FormsModule } from '@angular/forms';
import { GoogleMapsInputComponent } from './components/google-maps-input/google-maps-input.component';
import { UpdateDataComponent } from './components/update-data/update-data.component';

@NgModule({
  declarations: [
    SnowComponent,
    GoogleMapsInputComponent,
    UpdateDataComponent,
    // DialogDruo,
  ],
  imports: [CommonModule, CoreModule, FormsModule],
  exports: [
    SnowComponent,
    GoogleMapsInputComponent,
    UpdateDataComponent,
    // DialogDruo,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SharedModule {}
